import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from '../../universal-nav/hooks/useUniversalNavContext';
export const prepareAccountUsageData = (rawData) => {
    return {
        id: rawData.id,
        periodEnd: rawData.period_end,
        periodStart: rawData.period_start,
        tasks: {
            limit: rawData.limit.action_limit,
            total: rawData.zap_metrics.total_tasks,
        },
        zaps: {
            limit: rawData.limit.zap_limit,
            on: rawData.zap_metrics.zap_on_count,
        },
    };
};
export const useQueryAccountUsage = (currentAccountId) => {
    const { apiHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['accountUsage', currentAccountId],
        queryFn: async () => {
            if (!currentAccountId)
                throw new Error('currentAccountId is not available');
            const response = await fetch(`${apiHostname}/api/v4/accounts/${encodeURIComponent(currentAccountId)}/usage`, {
                credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return await response.json();
        },
        select: prepareAccountUsageData,
        enabled: !!currentAccountId,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
//# sourceMappingURL=useQueryAccountUsage.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
